import React, { useEffect, useState } from "react"
import Breadcrumb from "../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaPlus,
  FaTrash,
} from "react-icons/fa6"
import { Link } from "react-router-dom"
import Configs from "../../config"
import { Switch } from "antd"
import { calculateAge } from "utils/commonFunctions"
import Swal from "sweetalert2"
import WorkoutModal from "./addWorkout"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Loader from "components/Loader/loader"

const WorkoutIndex = () => {
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const [loading, setloading] = useState(false)
  const [workoutData, setWorkoutData] = useState([])
  const [data, setData] = useState([])
  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    getWorkoutData()
  }, [])

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(
        item =>
          item.activityTitle
            .toLowerCase()
            .includes(searchString.toLowerCase()) ||
          item.activityName
            .toLowerCase()
            .includes(searchString.toLowerCase())
      )
      setWorkoutData(filteredData)
      setPage(1)
    } else {
      setWorkoutData(data)
    }
  }, [searchString, data])

  async function getWorkoutData() {
    const APIData = await fetchData(setloading, "workout")

    if (APIData?.success) {
      setWorkoutData(APIData?.workouts)
      setData(APIData?.workouts)
    }
  }

  const totalPages = Math.ceil(workoutData?.length / itemsPerPage)
  const finalData = workoutData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingEvent, setEditingEvent] = useState(null) // NEW: event being edited

  const handleSaveActivity = async (activity, editid) => {
    if (editingEvent) {
      const APIData = await FetchPutData(
        setloading,
        "workout",
        editid,
        activity
      )

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Workout Updated Successfully",
          icon: "success",
        })
        getWorkoutData()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          text: APIData?.response?.data?.message,
        })
      }
    } else {
      const APIData = await FetchPostData(setloading, "workout", activity)

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Workout Added Successfully",
          icon: "success",
        })
        getWorkoutData()
      } else {
        Swal.fire({
          title: "Something went wrong",
          icon: "error",
          text: APIData?.response?.data?.message,
        })
      }
    }
    setIsModalOpen(false)
    setEditingEvent(null)
  }

  const handleDelete = userId => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete this Workout Item.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(setloading, "workout", userId)

        if (APIData?.data?.success) {
          Swal.fire({
            title: "Workout Deleted Successfully",
            icon: "success",
          })
          getWorkoutData()
        } else {
          Swal.fire({
            title: "Something went wrong",
            icon: "error",
            description: APIData?.response?.data?.message,
          })
        }
      }
    })
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="Workouts" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Workouts</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search Workouts"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    <button
                      className="btn btn-add"
                      onClick={() => setIsModalOpen(true)}
                    >
                      <FaPlus className="me-1" size={14} />
                      Add Workout
                    </button>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Workout Title</th>
                        <th>Workout Activity</th>
                        <th>Planned Duration</th>
                        <th>Planned Distance</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData?.map((user, index) => (
                        <tr key={user.id}>
                          <td>{index + 1}</td>
                          <td>{user?.activityTitle}</td>
                          <td>{user?.activityName}</td>
                          <td>{user?.plannedDuration ? `${user?.plannedDuration} Hrs` : "--"} </td>
                          <td>{user?.plannedDistance ? `${user?.plannedDistance} Mile` : "--"}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => {
                                setEditingEvent(user), setIsModalOpen(true)
                              }}
                            >
                              <FaPen size={12} />
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(user?._id)}
                            >
                              <FaTrash size={12} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {workoutData.length}{" "}
                    Workouts.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <WorkoutModal
        isOpen={isModalOpen}
        toggle={() => {
          setIsModalOpen(false)
          setEditingEvent(null)
        }}
        onSave={handleSaveActivity}
        event={editingEvent}
      />
    </div>
  )
}

export default WorkoutIndex
